import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/base/SEOHead';

export default function ArticlesPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <SEOHead
        title="品牌资讯｜欧美精品"
        description="了解欧美精品最新品牌资讯，包括时尚趋势、护肤指南、家居设计等高品质生活内容。关注欧美精品，掌握全球顶尖品牌动态。"
        keywords="欧美精品资讯,欧美品牌动态,欧美时尚趋势,欧美护肤品指南,欧美品质生活"
        canonicalUrl="https://www.oumeijingpin.com/articles"
      />
      <Navbar />
      <main className="pt-16">
        <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '品牌资讯' }]} />

        <section className="max-w-7xl mx-auto px-4 md:px-6 py-8">
          <h1 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 text-center mb-3">
            品牌资讯
          </h1>
          <p className="text-sm text-foreground-500 text-center mb-10 max-w-xl mx-auto">
            掌握欧美精品最新动态，了解更多品质生活灵感与品牌故事
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {articles.map((article) => (
              <Link
                key={article.id}
                to={`/articles/${article.slug}`}
                className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 flex flex-col sm:flex-row transition-colors hover:border-background-300/60"
              >
                <div className="w-full sm:w-[200px] flex-shrink-0 aspect-[16/10] sm:aspect-auto overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-4 md:p-5 flex flex-col justify-center flex-1">
                  <div className="flex items-center gap-3 text-[11px] text-foreground-400 mb-2">
                    <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-[10px]">
                      {article.category}
                    </span>
                    <span>{article.date}</span>
                    <span>·</span>
                    <span>{article.readTime}</span>
                  </div>
                  <h2 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h2>
                  <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{article.excerpt}</p>
                  <div className="mt-2 flex flex-wrap gap-1">
                    {article.tags.map((tag) => (
                      <span key={tag} className="text-[10px] px-2 py-0.5 rounded-full bg-background-100 text-foreground-400">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}